import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../../../spa/Components/Link/Link';
import {
    TEXT_ROW_ITEM_BLOCK_NAME,
} from '../text-row/constants';

const propTypes = {
    url: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
    dataShowBbLoader: PropTypes.bool,
    gtmAttribute: PropTypes.string,
};

/**
 * This React component is just a wrapper for the RouterLink javascript
 * component.
 * In the `params` property it can be passed the object that will be passed
 * to the `RouterLink` function.
 *
 * @see shared/components/text-row/RouterLink.jsx
 */
class RouterLink extends React.Component {
    /**
     * Default constructor.
     *
     * @param {Object} props React's properties.
     */
    constructor(props) {
        super(props);
    }

    /**
     * React's render method.
     *
     * @return {Object} The react element.
     */
    render() {
        return (
            <Link
                to={ this.props.url }
                onClick={ this.props.onClick }
                className={ TEXT_ROW_ITEM_BLOCK_NAME }
                data-show-bb-loader={ this.props.dataShowBbLoader }
                gtmAttribute={this.props.gtmAttribute}
            >
                {this.props.children}
            </Link>
        );
    }
}

RouterLink.propTypes = propTypes;

export default RouterLink;
